import { memo } from "react";
import { makeStyles } from "@mui/styles";
import { View } from "../Base";
import WaveItem from "./WaveItem";

const useStyles = makeStyles(({ typography }) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  list: {
    overflow: "auto",
    marginRight: "-14px",
  },
}));

const Waves = memo(({ waves }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <View className={styles.list}>
        {waves.map((wave) => (
          <WaveItem key={wave.waveName.toString()} wave={wave} />
        ))}
      </View>
    </View>
  );
});

export default Waves;
